import { create } from 'zustand';

export type UseCreditsPaginationStore = {
  page: number;
  rowsPerPage: number;
  maxPage: number;
};

const defaultValue: UseCreditsPaginationStore = {
  page: 1,
  rowsPerPage: 10,
  maxPage: 10,
};

const useCreditsPaginationStore = create<UseCreditsPaginationStore>(() => ({
  ...defaultValue,
}));

export const useCreditsPage = () =>
  useCreditsPaginationStore((state) => state.page);

export const useCreditsRowsPerPage = () =>
  useCreditsPaginationStore((state) => state.rowsPerPage);

export const useCreditsMaxPage = () =>
  useCreditsPaginationStore((state) => state.maxPage);

export const useCreditsPagination = () =>
  useCreditsPaginationStore((state) => state);

export const changeCreditsPage = (page: number) =>
  useCreditsPaginationStore.setState({ page });

export const changeCreditsMaxPage = (maxPage: number) =>
  useCreditsPaginationStore.setState({ maxPage });

export const changeCreditsRowsPerPage = (rowsPerPage: number) =>
  useCreditsPaginationStore.setState({ rowsPerPage, page: defaultValue.page });

export const resetCreditsPage = () =>
  useCreditsPaginationStore.setState({ page: defaultValue.page });

export const resetCreditsStore = () =>
  useCreditsPaginationStore.setState({ ...defaultValue });
